<template>
  <div
    class="w-full text-center box"
    style="height: 100vh; background-color: white"
  >
    <div style="padding-top: 60px">
      <svg
        width="125"
        height="128"
        viewBox="0 0 125 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="margin: auto"
      >
        <path
          d="M118.171 128C122.23 119.733 124.505 110.438 124.505 100.608C124.505 66.2203 96.6469 38.3484 62.2755 38.3484C27.9041 38.3484 0.0456543 66.2203 0.0456543 100.597C0.0456543 110.427 2.33188 119.721 6.38016 127.989H118.171V128Z"
          fill="#E10000"
        />
        <path
          d="M43.7972 112.893C41.9013 116.486 39.169 119.566 35.879 121.887C42.9831 120.938 49.2618 117.29 53.6112 111.99C50.4774 112.67 47.1986 112.994 43.7972 112.893ZM62.2765 35.5261C63.1687 35.5261 64.0609 35.5484 64.9419 35.5819C66.414 34.0309 67.8081 32.7032 69.124 31.632C63.1799 29.3559 56.7115 28.1062 49.9644 28.1062C44.2544 28.1062 38.7563 28.9988 33.5928 30.6613C38.9125 32.1788 43.9756 34.2987 48.7042 36.9542C53.0759 36.0282 57.626 35.5372 62.2765 35.5372M104.332 0C100.451 1.18271 96.8933 3.13531 93.8598 5.69042C86.0755 6.15904 79.7633 12.2288 78.9715 19.9834C78.2801 24.1564 78.0124 27.8607 71.1538 33.6181C69.6593 34.812 67.9531 36.441 66.1129 38.4605C64.8416 38.3824 63.5702 38.349 62.2765 38.349C43.0834 38.349 25.9312 47.0408 14.5112 60.6978C27.2583 58.7229 40.2619 57.5179 53.4774 57.1497C48.4923 64.1902 44.7451 73.2837 41.8121 82.2768C38.1095 92.2406 38.1987 99.8055 34.7861 106.634C32.2657 111.755 28.1059 115.895 22.9981 118.394C23.1654 118.394 23.3439 118.394 23.5223 118.405C30.9386 118.539 37.8976 116.509 43.786 112.893C43.786 112.893 43.786 112.893 43.7972 112.893C48.7711 84.2851 65.2207 59.7048 88.1499 43.9724C87.0792 42.1984 86.477 40.1007 86.5216 37.8803C86.622 31.9333 91.2502 27.1243 97.0605 26.6669H97.0717C96.4249 24.2456 96.1015 21.7129 96.1461 19.0796C96.2799 11.604 99.3802 4.87591 104.321 0"
          fill="black"
        />
        <path
          d="M97.0785 26.6555H97.0673C91.257 27.1018 86.6288 31.9108 86.5284 37.869C86.495 40.0894 87.086 42.187 88.1567 43.9611C65.2164 59.6934 48.7667 84.2738 43.804 112.882C74.3613 113.741 94.0785 81.3616 97.6138 51.7603C98.6398 43.1243 98.8963 33.6514 97.0896 26.6555"
          fill="white"
        />
        <path
          d="M90.0163 15.4087C88.7895 15.3864 87.8081 14.371 87.8305 13.1437C87.8528 11.9163 88.8676 10.9456 90.0832 10.9568C91.31 10.9791 92.2914 11.9944 92.2691 13.2218C92.2468 14.4491 91.2319 15.431 90.0052 15.4087"
          fill="white"
        />
      </svg>
    </div>

    <h1 style="padding-top: 20px">サービス統合のお知らせ</h1>
    <div class="maintenance-text">
      2024年7月6日より「PRONIアイミツメンバーズ」は<br class="pc-only" />
      「PRONIアイミツ」にサービスを統合いたしました。<br />
      これまでのお問い合わせや依頼内容の確認、新規案件の依頼などは<br class="pc-only" />
      PRONIアイミツのパートナーマイページで引き続きご利用いただけます。<br />
      <br />
      今後ともPRONIアイミツをよろしくお願いいたします。<br />
    </div>

    <div class="proni-login-box">
      <a class="proni-login-button" href="https://imitsu.jp/login">
        PRONIアイミツ パートナーマイページへ
      </a>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.box {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Hiragino Sans', 'Original Yu Gothic', 'Yu Gothic', 'Noto Sans CJK JP',
    sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Sans Emoji';
  letter-spacing: 0.64px;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.5;
  color: #333;
  font-family: 'Noto Sans JP';
}

.maintenance-text {
  /* PC/Body/Regular/L */
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 25.6px */
  letter-spacing: 0.64px;
  margin-top: 12px;
}

.proni-login-box {
  margin-top: 40px;
  display: block;
  color: #333;
}

.proni-login-button {
  margin: auto;
  display: flex;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 2px solid
    var(--Chromatic-Secondary-Outline-Light-Outline-1, rgba(159, 115, 86, 0.6));
  background: var(--GrayScale-Surface-Light, #fff);
  max-width: 348px;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
  letter-spacing: 0.64px;
  &:hover {
    background: rgba(159, 115, 86, .078);
    box-shadow: 0 4px 4px rgba(6, 16, 26, .302), 0 8px 12px 6px rgba(6, 16, 26, .149);
    text-decoration: none;
    transition: all .1s ease-out 0s;
  }
}
@media (max-width: 414px) {
  .pc-only {
    display: none;
  }
  .box {
    padding: 0 20px;
    text-align: left;
  }
}
</style>
